import { createAnimation } from "@ionic/angular";

/**
 * handle page animation between page
 *
 * @param el
 * @param opts
 * @returns
 */
export function animationPage(el: HTMLElement, opts) {
  const DURATION = 500;

  // root animation with common setup for the whole transition
  const rootTransition = createAnimation()
    .duration(opts.duration || DURATION)
    .easing("cubic-bezier(0.3,0,0.66,1)");

  // ensure that the entering page is visible from the start of the transition
  const enteringPage = createAnimation()
    .addElement(getIonPageElement(opts.enteringEl))
    .beforeRemoveClass("ion-page-invisible");

  // create animation for the leaving page
  const leavingPage = createAnimation().addElement(
    getIonPageElement(opts.leavingEl)
  );
  // actual customized animation
  if (opts.direction === "forward") {
    enteringPage.fromTo("transform", "translateX(100%)", "translateX(0)");
  } else {
    leavingPage
      .fromTo("transform", "translateX(0)", "translateX(100%)")
      // Ionic destroys the animation (clearing its styles) one frame before Angular removes
      // the page: hide it on finish, like Ionic's own transitions, or it flashes back in place
      .onFinish((currentStep: number) => {
        if (currentStep === 1 && leavingPage.elements.length > 0) {
          leavingPage.elements[0].style.setProperty("display", "none");
        }
      });
  }

  // include animations for both pages into the root animation
  rootTransition.addAnimation(enteringPage);
  rootTransition.addAnimation(leavingPage);

  return rootTransition;
}

export const getIonPageElement = (element: HTMLElement) => {
  if (element.classList.contains("ion-page")) {
    return element;
  }

  const ionPage = element.querySelector(
    ":scope > .ion-page, :scope > ion-nav, :scope > ion-tabs"
  );
  if (ionPage) {
    return ionPage;
  }
  // idk, return the original element so at least something animates
  // and we don't have a null pointer
  return element;
};
